import { render, staticRenderFns } from "./DigerAlacakForm.vue?vue&type=template&id=5e2fd44a"
import script from "./DigerAlacakForm.vue?vue&type=script&lang=ts"
export * from "./DigerAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports